import { dataProps, subItemProps } from './properties'

export const setInventoryVariantList = (state, payload) => {
    state.list = payload
}    

export const setInventoryVariantData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(subItemProps))]
    } else if(payload.copy) {
        state.props.sub_item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const addNewInventoryVariantSubCategoryItemRow = state => {

    let key = 0
    state.props.sub_item_list.push(JSON.parse(JSON.stringify(subItemProps)))

    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('sub_category_name_'+(key-1)).focus()
    }, 300);

}

export const removeInventoryVariantSubCategoryItemRow = (state, payload) => {

    let key = 0

    state.props.deleted_sub_item_list_items.push(state.props.sub_item_list[payload])

    state.props.sub_item_list.splice(payload, 1)

    if(state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(subItemProps))]
    }

    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetInventoryVariantData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryVariant/mutations.js